
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Label } from '@/modules/common/components/__deprecated__/Label';
import {
  InputNumber,
  BaseText,
  Heading,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';
import { Tooltip } from '@/modules/common/components/Tooltip';
import { Button } from '@/modules/common/components/__deprecated__/Button';
import { SimpleButton } from '@/modules/common/components/__deprecated__/SimpleButton';
import { Graph } from '@/modules/pension/components/Graph';
import { moneyViewer as money } from '@/modules/common/helpers/currency';
import {
  ActionFetchSimulatorConfig,
  ActionResetSimulator,
  ActionSimulatePension,
  ActionSimulatorAskForContact,
  State
} from '@/modules/pension/store/pension-landing';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

const PensionModule = namespace('PensionLandingModule');

@Component({
  components: {
    InputNumber,
    Label,
    Tooltip,
    Button,
    SimpleButton,
    Graph,
    LoaderIndicator,
    BaseText,
    Heading
  },
  filters: { money }
})
export default class PensionSimulator extends Vue {
  readonly NebraskaColors = NebraskaColors;

  @PensionModule.State('data')
  state!: State;

  @PensionModule.Action('fetchSimulatorConfig')
  private fetchSimulatorConfig!: ActionFetchSimulatorConfig;

  @PensionModule.Action('simulatePension')
  simulatePension!: ActionSimulatePension;

  @PensionModule.Action('resetSimulator')
  resetSimulator!: ActionResetSimulator;

  @PensionModule.Action('simulatorAskForContact')
  simulatorAskForContact!: ActionSimulatorAskForContact;

  get computedInitialInvestmentLabel() {
    const { type } = this.state.lead;
    return type === 'migration'
      ? 'Valor da portabilidade'
      : 'Investimento inicial';
  }

  private created() {
    this.fetchSimulatorConfig();
  }
}
